import { render, staticRenderFns } from "./dialog-view-leg.vue?vue&type=template&id=c9315edc&"
import script from "./dialog-view-leg.vue?vue&type=script&lang=js&"
export * from "./dialog-view-leg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-view-leg.vue"
export default component.exports